import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'umi';
import { FILTER_NAMESPACE } from '@/pages/intelligence/models/filter';
import { hasAllProperties } from '@intelligence/utils/filterUtils';
// import { isEmpty } from '@/pages/intelligence/utils/commonUtils';

// 整合全局公共配置对象loading状态
// export const getCondLoadingObj = (data: any = {}, booleanValue: boolean) => {
//   console.log('datadata', data);
//   const loadingObj = Object.keys(data).reduce(
//     (acc, key) => ({
//       ...acc,
//       [key]: booleanValue,
//     }),
//     {},
//   );
//   console.log('loadingObjloadingObj', loadingObj);
//   return loadingObj;
// };

// 整合全局公共配置对象loading状态
export const COND_PARAMS = {
  mobileMainGenre: {
    mobileMainGenre: {
      target: 'mobile_main_genre',
      params: {},
    },
  },
  genreMap: {
    genreMap: {
      target: 'filter_genre',
      params: {
        entity_type: ["mobile"],
        need_filter: true,
      }
    }
  }
};

/**
 * 从接口获取 QueryDefinition 数据，并保存到公共状态
 */
function useSetQueryDefinition(props: any) {
  const dispatch = useDispatch();

  const [condDatas, setCondDatas] = useState<any>({});
  const [filterLoading, setFilterLoading] = useState<any>(true);
  // console.log('useSetQueryDefinition', props);

  const { commonCondFilter } = useSelector((state) => {
    // @ts-ignore
    const { commonCondFilter } = state[FILTER_NAMESPACE];
    return {
      commonCondFilter,
    };
  });

  // console.log('commonCondFiltercommonCondFiltercommonCondFilter234234', commonCondFilter);

  const modelValueName = () => {
    return {
      modelName: commonCondFilter,
      dispatchType: `${FILTER_NAMESPACE}/getCommonCondFilter`,
      payload: {},
    };
  };

  const modelMsg = modelValueName();

  const getGenreFilterApiData = async () => {
    const { modelName, dispatchType, payload } = modelMsg;
    // console.log('modelMsgmodelMsgmodelMsgmodelMsg2222', modelMsg);
    // console.log('propspropsprops222', props);
    // console.log(
    //   '!hasAllProperties(props, modelName.data)',
    //   !hasAllProperties(props, modelName.data),
    // );
    if (modelName.loading === false && !hasAllProperties(props, modelName.data)) {
      const dataParams = { ...payload, ...props };
      // console.log('dataParamsdataParams', dataParams);
      try {
        setFilterLoading(true);
        // 如果数据为空则重新请求接口
        const res = await dispatch({
          type: dispatchType,
          payload: { paramsValue: dataParams, condDatas: modelName.data },
        });
        // console.log('condDatasfwefwefwefmodelNamedata', modelName.data);
        // console.log('resresres', res);
        setCondDatas({
          ...modelName.data,
          ...res,
        });
        setFilterLoading(false);
      } catch (err) {
        setFilterLoading(false);
      }
    } else {
      setFilterLoading(false);
      setCondDatas(modelName.data);
    }
  };

  useEffect(() => {
    // console.log('modelMsgmodelMsgmodelMsgmodelMsg~~~~~~~~~~~', modelMsg);
    // console.log('useSetQueryDefinitionprops~~~~~~~~~~~', props);
    // console.log('commonCondFiltercommonCondFilter~~~~~~~~~~', commonCondFilter);
    // 不能用!val， 因为它可能是undefind
    if (modelMsg?.modelName?.loading === false) {
      getGenreFilterApiData();
    }
  }, []);

  return {
    filterLoading,
    condDatas,
  };
}

// 获取公共配置
// const metricsDatasource: TMetricsDataSource = useQueryDefinition('datasource');

export default useSetQueryDefinition;

/**
 * 从公共状态中获取 QueryDefinition
 *
 * @param {?string} [key] 传入对应 key 获取对应字段数据，不传返回全部数据
 * @param {*} defaultValue 对应 key 值无数据时的兜底默认值
 * @returns {*}
 */
export const useQueryDefinition = (key?: string, defaultValue?: any) => {
  const { commonCondFilter = {} } = useSelector((state: any) => {
    const { commonCondFilter } = state[FILTER_NAMESPACE] || {};
    return { commonCondFilter };
  });
  const { loading, loadingStd, data = {} } = commonCondFilter;

  const definition = useMemo(() => {
    if (key) {
      return data?.[key] ?? defaultValue;
    } else {
      return { ...data, loading, loadingStd };
    }
  }, [loading, key, defaultValue, data]);

  return definition;
};

export const FULL_GENRE = {
  annir: [
    {
      main_genre: {
        genre: 'Action',
        genre_cn: '动作',
        genre_en: 'Action',
      },
      sub_genre: [
        {
          genre: 'Artillery Shooter',
          genre_cn: '火炮射击',
          genre_en: 'Artillery Shooter',
        },
        {
          genre: 'Asymmetric Battle',
          genre_cn: '电动战斗',
          genre_en: 'Asymmetric Battle',
        },
        {
          genre: 'Brawl',
          genre_cn: '斗殴',
          genre_en: 'Brawl',
        },
        {
          genre: 'Fighting',
          genre_cn: '格斗',
          genre_en: 'Fighting',
        },
        {
          genre: 'MOBA',
          genre_cn: '多人在线战术竞技游戏',
          genre_en: 'MOBA',
        },
        {
          genre: 'Music & Rhythm',
          genre_cn: '音乐和节奏',
          genre_en: 'Music & Rhythm',
        },
        {
          genre: 'Open World',
          genre_cn: '开放世界',
          genre_en: 'Open World',
        },
        {
          genre: 'Other Action',
          genre_cn: '其他动作',
          genre_en: 'Other Action',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Platformer',
          genre_cn: '平台',
          genre_en: 'Platformer',
        },
        {
          genre: 'Royale Battle',
          genre_cn: '大逃杀',
          genre_en: 'Royale Battle',
        },
        {
          genre: 'Run & Gun Platformer',
          genre_cn: '跑跑卡丁车',
          genre_en: 'Run & Gun Platformer',
        },
        {
          genre: 'Runner',
          genre_cn: '竞速',
          genre_en: 'Runner',
        },
        {
          genre: 'Shark',
          genre_cn: '鲨鱼',
          genre_en: 'Shark',
        },
        {
          genre: "Shoot'em Up",
          genre_cn: '射击',
          genre_en: "Shoot'em Up",
        },
        {
          genre: 'Slicing',
          genre_cn: '切片',
          genre_en: 'Slicing',
        },
        {
          genre: 'Stealth',
          genre_cn: '潜行',
          genre_en: 'Stealth',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Casino',
        genre_cn: '赌博',
        genre_en: 'Casino',
      },
      sub_genre: [
        {
          genre: 'Bingo',
          genre_cn: '宾果游戏',
          genre_en: 'Bingo',
        },
        {
          genre: 'Card Games Casino',
          genre_cn: '纸牌赌博',
          genre_en: 'Card Games Casino',
        },
        {
          genre: 'Chinese Card/Board',
          genre_cn: '中国卡牌/棋牌',
          genre_en: 'Chinese Card/Board',
        },
        {
          genre: 'Claw Machine',
          genre_cn: '娃娃机',
          genre_en: 'Claw Machine',
        },
        {
          genre: 'Coin Pusher',
          genre_cn: '推币机',
          genre_en: 'Coin Pusher',
        },
        {
          genre: 'Dominoes',
          genre_cn: '多米诺骨牌',
          genre_en: 'Dominoes',
        },
        {
          genre: 'Fish Hunter',
          genre_cn: '捕鱼达人',
          genre_en: 'Fish Hunter',
        },
        {
          genre: 'Lotto/Scratchers',
          genre_cn: '乐透/刮刮乐',
          genre_en: 'Lotto/Scratchers',
        },
        {
          genre: 'Mahjong',
          genre_cn: '麻将',
          genre_en: 'Mahjong',
        },
        {
          genre: 'Okey',
          genre_cn: '奥基',
          genre_en: 'Okey',
        },
        {
          genre: 'Other Casino',
          genre_cn: '其他赌场',
          genre_en: 'Other Casino',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Pachinko',
          genre_cn: '柏青哥',
          genre_en: 'Pachinko',
        },
        {
          genre: 'Poker',
          genre_cn: '扑克牌',
          genre_en: 'Poker',
        },
        {
          genre: 'Slots',
          genre_cn: '老虎机',
          genre_en: 'Slots',
        },
        {
          genre: 'Teen Patti',
          genre_cn: '青少年帕蒂',
          genre_en: 'Teen Patti',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Hypercasual',
        genre_cn: '超休闲',
        genre_en: 'Hypercasual',
      },
      sub_genre: [
        {
          genre: '.io',
          genre_cn: '休闲竞技',
          genre_en: '.io',
        },
        {
          genre: 'Action',
          genre_cn: '动作',
          genre_en: 'Action',
        },
        {
          genre: 'Ball',
          genre_cn: '球类',
          genre_en: 'Ball',
        },
        {
          genre: 'Escape',
          genre_cn: '逃脱',
          genre_en: 'Escape',
        },
        {
          genre: 'Merge HC',
          genre_cn: '战场策略HC',
          genre_en: 'Merge HC',
        },
        {
          genre: 'Music',
          genre_cn: '音乐',
          genre_en: 'Music',
        },
        {
          genre: 'Other Hypercasual',
          genre_cn: '其他休闲游戏',
          genre_en: 'Other Hypercasual',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Puzzle',
          genre_cn: '解密',
          genre_en: 'Puzzle',
        },
        {
          genre: 'Racing',
          genre_cn: '竞速',
          genre_en: 'Racing',
        },
        {
          genre: 'Shooting',
          genre_cn: '射击',
          genre_en: 'Shooting',
        },
        {
          genre: 'Simulation',
          genre_cn: '模拟生活',
          genre_en: 'Simulation',
        },
        {
          genre: 'Sports',
          genre_cn: '运动',
          genre_en: 'Sports',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Kids',
        genre_cn: '儿童',
        genre_en: 'Kids',
      },
      sub_genre: [
        {
          genre: 'Action Kids',
          genre_cn: '儿童动作游戏',
          genre_en: 'Action Kids',
        },
        {
          genre: 'Coloring & Drawing',
          genre_cn: '填色与绘画',
          genre_en: 'Coloring & Drawing',
        },
        {
          genre: 'Cooking & Crafting',
          genre_cn: '烹饪和手工制作',
          genre_en: 'Cooking & Crafting',
        },
        {
          genre: 'Creative World',
          genre_cn: '创意世界',
          genre_en: 'Creative World',
        },
        {
          genre: 'Educational',
          genre_cn: '教育',
          genre_en: 'Educational',
        },
        {
          genre: 'Fashion & Dressing Up',
          genre_cn: '时尚与装扮',
          genre_en: 'Fashion & Dressing Up',
        },
        {
          genre: 'Other Kids',
          genre_cn: '其他儿童',
          genre_en: 'Other Kids',
        },
        {
          genre: 'Other Simulation',
          genre_cn: '其他模拟',
          genre_en: 'Other Simulation',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Pets & Caring',
          genre_cn: '宠物护理',
          genre_en: 'Pets & Caring',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Match',
        genre_cn: '连连看',
        genre_en: 'Match',
      },
      sub_genre: [
        {
          genre: 'Blast',
          genre_cn: '爆炸',
          genre_en: 'Blast',
        },
        {
          genre: 'Blast-Meta',
          genre_cn: '爆破游戏',
          genre_en: 'Blast-Meta',
        },
        {
          genre: 'Blast-Saga',
          genre_cn: '爆破传奇',
          genre_en: 'Blast-Saga',
        },
        {
          genre: 'Bubble Shooter',
          genre_cn: '泡泡射击',
          genre_en: 'Bubble Shooter',
        },
        {
          genre: 'Connect Tiles',
          genre_cn: '连接瓷砖',
          genre_en: 'Connect Tiles',
        },
        {
          genre: 'Line',
          genre_cn: '线条',
          genre_en: 'Line',
        },
        {
          genre: 'Line-Saga',
          genre_cn: '连连看传奇',
          genre_en: 'Line-Saga',
        },
        {
          genre: 'M3',
          genre_cn: '',
          genre_en: 'M3',
        },
        {
          genre: 'M3-Meta',
          genre_cn: 'M3-Meta',
          genre_en: 'M3-Meta',
        },
        {
          genre: 'M3-Saga',
          genre_cn: 'M3 传奇',
          genre_en: 'M3-Saga',
        },
        {
          genre: 'Merge',
          genre_cn: '合并',
          genre_en: 'Merge',
        },
        {
          genre: 'Other Match',
          genre_cn: '其他比赛',
          genre_en: 'Other Match',
        },
        {
          genre: 'Other-Meta',
          genre_cn: '其他游戏',
          genre_en: 'Other-Meta',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Other',
        genre_cn: '其他',
        genre_en: 'Other',
      },
      sub_genre: [
        {
          genre: 'Other',
          genre_cn: '其他',
          genre_en: 'Other',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Party',
        genre_cn: '派对',
        genre_en: 'Party',
      },
      sub_genre: [
        {
          genre: 'Guess Something',
          genre_cn: '猜猜看',
          genre_en: 'Guess Something',
        },
        {
          genre: 'Karaoke',
          genre_cn: '卡拉 OK',
          genre_en: 'Karaoke',
        },
        {
          genre: 'Luck Battle',
          genre_cn: '幸运大作战',
          genre_en: 'Luck Battle',
        },
        {
          genre: 'Mafia/Betrayal',
          genre_cn: '黑手党/背叛',
          genre_en: 'Mafia/Betrayal',
        },
        {
          genre: 'Mini Games Collection',
          genre_cn: '迷你游戏集锦',
          genre_en: 'Mini Games Collection',
        },
        {
          genre: 'Other Party',
          genre_cn: '其他派对',
          genre_en: 'Other Party',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Party Royale',
          genre_cn: '派对大逃杀',
          genre_en: 'Party Royale',
        },
        {
          genre: 'Quiz',
          genre_cn: '问答',
          genre_en: 'Quiz',
        },
        {
          genre: 'Truth or Dare',
          genre_cn: '真心话大冒险',
          genre_en: 'Truth or Dare',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Puzzle',
        genre_cn: '解密',
        genre_en: 'Puzzle',
      },
      sub_genre: [
        {
          genre: 'Adventure Puzzle',
          genre_cn: '冒险益智',
          genre_en: 'Adventure Puzzle',
        },
        {
          genre: 'Block Puzzle',
          genre_cn: '方块拼图',
          genre_en: 'Block Puzzle',
        },
        {
          genre: 'Brain Puzzle',
          genre_cn: '脑力益智',
          genre_en: 'Brain Puzzle',
        },
        {
          genre: 'Brick-crusher',
          genre_cn: '碎砖游戏',
          genre_en: 'Brick-crusher',
        },
        {
          genre: 'Detective',
          genre_cn: '侦探',
          genre_en: 'Detective',
        },
        {
          genre: 'Hidden Object',
          genre_cn: '隐藏物品',
          genre_en: 'Hidden Object',
        },
        {
          genre: 'Hybrid Puzzle',
          genre_cn: '混合拼图',
          genre_en: 'Hybrid Puzzle',
        },
        {
          genre: 'Jigsaw',
          genre_cn: '拼图',
          genre_en: 'Jigsaw',
        },
        {
          genre: 'Klotski',
          genre_cn: '华容道',
          genre_en: 'Klotski',
        },
        {
          genre: 'Maze',
          genre_cn: '迷宫',
          genre_en: 'Maze',
        },
        {
          genre: 'Minesweeper',
          genre_cn: '扫雷',
          genre_en: 'Minesweeper',
        },
        {
          genre: 'Nonogram',
          genre_cn: '绘画逻辑拼图',
          genre_en: 'Nonogram',
        },
        {
          genre: 'Other Puzzle',
          genre_cn: '其他益智',
          genre_en: 'Other Puzzle',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Physics',
          genre_cn: '物理',
          genre_en: 'Physics',
        },
        {
          genre: 'Room Escape',
          genre_cn: '密室逃脱',
          genre_en: 'Room Escape',
        },
        {
          genre: 'Spot the Difference',
          genre_cn: '找不同',
          genre_en: 'Spot the Difference',
        },
        {
          genre: 'Sudoku',
          genre_cn: '数独',
          genre_en: 'Sudoku',
        },
        {
          genre: 'Tile-Matching',
          genre_cn: '消除',
          genre_en: 'Tile-Matching',
        },
        {
          genre: 'Word',
          genre_cn: '文字',
          genre_en: 'Word',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Racing',
        genre_cn: '竞速',
        genre_en: 'Racing',
      },
      sub_genre: [
        {
          genre: 'Arcade Racing',
          genre_cn: '街机赛车',
          genre_en: 'Arcade Racing',
        },
        {
          genre: 'Competitive Racing',
          genre_cn: '竞技赛车',
          genre_en: 'Competitive Racing',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Simulation Racing',
          genre_cn: '模拟赛车',
          genre_en: 'Simulation Racing',
        },
      ],
    },
    {
      main_genre: {
        genre: 'RPG',
        genre_cn: '角色扮演',
        genre_en: 'RPG',
      },
      sub_genre: [
        {
          genre: 'Action RPG',
          genre_cn: '动作角色扮演',
          genre_en: 'Action RPG',
        },
        {
          genre: 'Empire Simulation RPG',
          genre_cn: '帝国模拟 RPG',
          genre_en: 'Empire Simulation RPG',
        },
        {
          genre: 'Idle RPG',
          genre_cn: '空闲角色扮演',
          genre_en: 'Idle RPG',
        },
        {
          genre: 'Location RPG',
          genre_cn: '定位角色扮演',
          genre_en: 'Location RPG',
        },
        {
          genre: 'MMORPG',
          genre_cn: '大型多人在线角色扮演游戏',
          genre_en: 'MMORPG',
        },
        {
          genre: 'Open World RPG',
          genre_cn: '开放世界 RPG',
          genre_en: 'Open World RPG',
        },
        {
          genre: 'Other RPG',
          genre_cn: '其他角色扮演',
          genre_en: 'Other RPG',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Puzzle RPG',
          genre_cn: '益智 RPG',
          genre_en: 'Puzzle RPG',
        },
        {
          genre: 'Roguelike ARPG',
          genre_cn: '肉鸽动作角色扮演',
          genre_en: 'Roguelike ARPG',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Tactics',
          genre_cn: '战术',
          genre_en: 'Tactics',
        },
        {
          genre: 'Team Battle',
          genre_cn: '团队作战',
          genre_en: 'Team Battle',
        },
        {
          genre: 'Tower Defense RPG',
          genre_cn: '塔防 RPG',
          genre_en: 'Tower Defense RPG',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Shooting',
        genre_cn: '射击',
        genre_en: 'Shooting',
      },
      sub_genre: [
        {
          genre: 'Battle Royale',
          genre_cn: '大逃杀',
          genre_en: 'Battle Royale',
        },
        {
          genre: 'Cover-fire',
          genre_cn: '火力掩护',
          genre_en: 'Cover-fire',
        },
        {
          genre: 'Extraction Shooter',
          genre_cn: '禁区射击游戏',
          genre_en: 'Extraction Shooter',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'PvE Shooting',
          genre_cn: 'PvE 射击',
          genre_en: 'PvE Shooting',
        },
        {
          genre: 'Sniper',
          genre_cn: '狙击',
          genre_en: 'Sniper',
        },
        {
          genre: 'Team Deathmatch',
          genre_cn: '团队死亡竞赛',
          genre_en: 'Team Deathmatch',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Simulation',
        genre_cn: '模拟生活',
        genre_en: 'Simulation',
      },
      sub_genre: [
        {
          genre: 'Animal Avatar',
          genre_cn: '动物头像',
          genre_en: 'Animal Avatar',
        },
        {
          genre: 'Avatar Life',
          genre_cn: '虚拟生活',
          genre_en: 'Avatar Life',
        },
        {
          genre: 'Build Breed',
          genre_cn: '建造繁殖',
          genre_en: 'Build Breed',
        },
        {
          genre: 'Building',
          genre_cn: '建筑',
          genre_en: 'Building',
        },
        {
          genre: 'Creative Sandbox',
          genre_cn: '创意沙盒',
          genre_en: 'Creative Sandbox',
        },
        {
          genre: 'Dating',
          genre_cn: '约会',
          genre_en: 'Dating',
        },
        {
          genre: 'Dress Up & Lifestyle',
          genre_cn: '装扮与生活方式',
          genre_en: 'Dress Up & Lifestyle',
        },
        {
          genre: 'Driving',
          genre_cn: '驾驶',
          genre_en: 'Driving',
        },
        {
          genre: 'Farming',
          genre_cn: '农场',
          genre_en: 'Farming',
        },
        {
          genre: 'Game Console Emulator',
          genre_cn: '游戏机模拟器',
          genre_en: 'Game Console Emulator',
        },
        {
          genre: 'Home Design',
          genre_cn: '家居设计',
          genre_en: 'Home Design',
        },
        {
          genre: 'Idle',
          genre_cn: '空闲游戏',
          genre_en: 'Idle',
        },
        {
          genre: 'Idol Training Sim',
          genre_cn: '偶像训练模拟',
          genre_en: 'Idol Training Sim',
        },
        {
          genre: 'Interactive Story',
          genre_cn: '互动小说',
          genre_en: 'Interactive Story',
        },
        {
          genre: 'Life Simulator',
          genre_cn: '生活模拟器',
          genre_en: 'Life Simulator',
        },
        {
          genre: 'Manager',
          genre_cn: '经理人',
          genre_en: 'Manager',
        },
        {
          genre: 'Other Japanese Sim',
          genre_cn: '其他日本模拟游戏',
          genre_en: 'Other Japanese Sim',
        },
        {
          genre: 'Other Sim',
          genre_cn: '其他模拟',
          genre_en: 'Other Sim',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Pet',
          genre_cn: '宠物',
          genre_en: 'Pet',
        },
        {
          genre: 'Time Management',
          genre_cn: '时间管理',
          genre_en: 'Time Management',
        },
        {
          genre: 'Weapon Simulator',
          genre_cn: '武器模拟器',
          genre_en: 'Weapon Simulator',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Sports',
        genre_cn: '运动',
        genre_en: 'Sports',
      },
      sub_genre: [
        {
          genre: 'Arcade Sports',
          genre_cn: '街机运动',
          genre_en: 'Arcade Sports',
        },
        {
          genre: 'Fantasy Sports',
          genre_cn: '梦幻体育',
          genre_en: 'Fantasy Sports',
        },
        {
          genre: 'Live Sports',
          genre_cn: '实时体育',
          genre_en: 'Live Sports',
        },
        {
          genre: 'Management Sim',
          genre_cn: '模拟管理',
          genre_en: 'Management Sim',
        },
        {
          genre: 'Other Sports',
          genre_cn: '其他运动',
          genre_en: 'Other Sports',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Simulation Sports',
          genre_cn: '模拟运动',
          genre_en: 'Simulation Sports',
        },
        {
          genre: 'Sports Betting',
          genre_cn: '体育博彩',
          genre_en: 'Sports Betting',
        },
        {
          genre: 'Sports News',
          genre_cn: '体育新闻',
          genre_en: 'Sports News',
        },
        {
          genre: 'Sports TV',
          genre_cn: '体育电视',
          genre_en: 'Sports TV',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Strategy',
        genre_cn: '策略',
        genre_en: 'Strategy',
      },
      sub_genre: [
        {
          genre: '4X March-Battle',
          genre_cn: '4X 行军战斗',
          genre_en: '4X March-Battle',
        },
        {
          genre: 'Auto Chess',
          genre_cn: '自动国际象棋',
          genre_en: 'Auto Chess',
        },
        {
          genre: 'Build-Battle',
          genre_cn: '建造-战斗',
          genre_en: 'Build-Battle',
        },
        {
          genre: 'CCG-Battle',
          genre_cn: '卡牌收集战斗',
          genre_en: 'CCG-Battle',
        },
        {
          genre: 'Lane-Battle',
          genre_cn: '巷战',
          genre_en: 'Lane-Battle',
        },
        {
          genre: 'Legion Battle',
          genre_cn: '军团战',
          genre_en: 'Legion Battle',
        },
        {
          genre: 'Other Strategy',
          genre_cn: '其他策略',
          genre_en: 'Other Strategy',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Summon-Battle',
          genre_cn: '召唤战斗',
          genre_en: 'Summon-Battle',
        },
        {
          genre: 'Tower Defense Strategy',
          genre_cn: '塔防策略',
          genre_en: 'Tower Defense Strategy',
        },
        {
          genre: 'Turn-Based Strategy',
          genre_cn: '回合制战略',
          genre_en: 'Turn-Based Strategy',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Tabletop',
        genre_cn: '桌面游戏',
        genre_en: 'Tabletop',
      },
      sub_genre: [
        {
          genre: 'Board Game',
          genre_cn: '棋盘',
          genre_en: 'Board Game',
        },
        {
          genre: 'Card Games Tabletop',
          genre_cn: '桌面纸牌游戏',
          genre_en: 'Card Games Tabletop',
        },
        {
          genre: 'Chess',
          genre_cn: '象棋',
          genre_en: 'Chess',
        },
        {
          genre: 'Coloring',
          genre_cn: '着色',
          genre_en: 'Coloring',
        },
        {
          genre: 'Dice',
          genre_cn: '骰子',
          genre_en: 'Dice',
        },
        {
          genre: 'Go-Stop',
          genre_cn: '花札',
          genre_en: 'Go-Stop',
        },
        {
          genre: 'Hanafuda',
          genre_cn: '花札',
          genre_en: 'Hanafuda',
        },
        {
          genre: 'Ludo',
          genre_cn: '飞行棋',
          genre_en: 'Ludo',
        },
        {
          genre: 'Mahjong Solitaire',
          genre_cn: '麻将接龙',
          genre_en: 'Mahjong Solitaire',
        },
        {
          genre: 'Othello',
          genre_cn: '黑白棋',
          genre_en: 'Othello',
        },
        {
          genre: 'Other Tabletop',
          genre_cn: '其他桌面游戏',
          genre_en: 'Other Tabletop',
        },
        {
          genre: 'Others',
          genre_cn: '其他',
          genre_en: 'Others',
        },
        {
          genre: 'Solitaire',
          genre_cn: '接龙',
          genre_en: 'Solitaire',
        },
      ],
    },
  ],
  ieg: [
    {
      main_genre: {
        genre: 'Action',
        genre_cn: '动作',
        genre_en: 'Action',
      },
      sub_genre: [
        {
          genre: '2D Fighter',
          genre_cn: '2D战斗',
          genre_en: '2D Fighter',
        },
        {
          genre: 'Action RPG',
          genre_cn: '动作角色扮演',
          genre_en: 'Action RPG',
        },
        {
          genre: 'Automobile Sim',
          genre_cn: '模拟驾驶',
          genre_en: 'Automobile Sim',
        },
        {
          genre: 'Building',
          genre_cn: '建筑',
          genre_en: 'Building',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Fighting',
          genre_cn: '格斗',
          genre_en: 'Fighting',
        },
        {
          genre: 'Hack and Slash',
          genre_cn: '砍杀游戏',
          genre_en: 'Hack and Slash',
        },
        {
          genre: 'MOBA',
          genre_cn: '多人在线战术竞技游戏',
          genre_en: 'MOBA',
        },
        {
          genre: 'Open World',
          genre_cn: '开放世界',
          genre_en: 'Open World',
        },
        {
          genre: 'Open World Survival Craft',
          genre_cn: '开放世界生存建造',
          genre_en: 'Open World Survival Craft',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Adventure',
        genre_cn: '冒险游戏',
        genre_en: 'Adventure',
      },
      sub_genre: [
        {
          genre: 'Base Building',
          genre_cn: '基地建设',
          genre_en: 'Base Building',
        },
        {
          genre: 'Exploration',
          genre_cn: '探索',
          genre_en: 'Exploration',
        },
        {
          genre: 'Open World',
          genre_cn: '开放世界',
          genre_en: 'Open World',
        },
        {
          genre: 'Open World Survival Craft',
          genre_cn: '开放世界生存建造',
          genre_en: 'Open World Survival Craft',
        },
        {
          genre: 'Sandbox',
          genre_cn: '沙盒',
          genre_en: 'Sandbox',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Walking Simulator',
          genre_cn: '步行模拟器',
          genre_en: 'Walking Simulator',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Casino',
        genre_cn: '赌博',
        genre_en: 'Casino',
      },
      sub_genre: [
        {
          genre: 'Board Game',
          genre_cn: '棋盘',
          genre_en: 'Board Game',
        },
        {
          genre: 'Chess',
          genre_cn: '象棋',
          genre_en: 'Chess',
        },
        {
          genre: 'Gambling',
          genre_cn: '赌博',
          genre_en: 'Gambling',
        },
        {
          genre: 'Solitaire',
          genre_cn: '接龙',
          genre_en: 'Solitaire',
        },
        {
          genre: 'Word game',
          genre_cn: '文字游戏',
          genre_en: 'Word game',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Casual',
        genre_cn: '休闲',
        genre_en: 'Casual',
      },
      sub_genre: [
        {
          genre: '2D Platformer',
          genre_cn: '2D平台',
          genre_en: '2D Platformer',
        },
        {
          genre: '3D Platformer',
          genre_cn: '3D平台',
          genre_en: '3D Platformer',
        },
        {
          genre: 'Asymmetric',
          genre_cn: '电动游戏',
          genre_en: 'Asymmetric',
        },
        {
          genre: 'Automobile Sim',
          genre_cn: '模拟驾驶',
          genre_en: 'Automobile Sim',
        },
        {
          genre: 'Base Building',
          genre_cn: '基地建设',
          genre_en: 'Base Building',
        },
        {
          genre: 'Battle Royale',
          genre_cn: '大逃杀',
          genre_en: 'Battle Royale',
        },
        {
          genre: 'Board Game',
          genre_cn: '棋盘',
          genre_en: 'Board Game',
        },
        {
          genre: 'Bullet Hell',
          genre_cn: '子弹地狱',
          genre_en: 'Bullet Hell',
        },
        {
          genre: 'Card Battler',
          genre_cn: '卡牌对战',
          genre_en: 'Card Battler',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Casual Multiplayer',
          genre_cn: '休闲多人游戏',
          genre_en: 'Casual Multiplayer',
        },
        {
          genre: 'Choice Matter',
          genre_cn: '选择向游戏',
          genre_en: 'Choice Matter',
        },
        {
          genre: 'Choices Matter',
          genre_cn: '选择向',
          genre_en: 'Choices Matter',
        },
        {
          genre: 'Clicker',
          genre_cn: '点击',
          genre_en: 'Clicker',
        },
        {
          genre: 'Cooking',
          genre_cn: '烹饪',
          genre_en: 'Cooking',
        },
        {
          genre: 'Creature Collector',
          genre_cn: '生物收集',
          genre_en: 'Creature Collector',
        },
        {
          genre: 'Customization',
          genre_cn: '自定义',
          genre_en: 'Customization',
        },
        {
          genre: 'Dating Sim',
          genre_cn: '模拟约会',
          genre_en: 'Dating Sim',
        },
        {
          genre: 'Design & Illustration',
          genre_cn: '设计和插图',
          genre_en: 'Design & Illustration',
        },
        {
          genre: 'Education',
          genre_cn: '教育',
          genre_en: 'Education',
        },
        {
          genre: 'Farm simulation',
          genre_cn: '农场模拟',
          genre_en: 'Farm simulation',
        },
        {
          genre: 'Hidden Object',
          genre_cn: '隐藏物品',
          genre_en: 'Hidden Object',
        },
        {
          genre: 'Horses',
          genre_cn: '赛马',
          genre_en: 'Horses',
        },
        {
          genre: 'Hunting',
          genre_cn: '狩猎',
          genre_en: 'Hunting',
        },
        {
          genre: 'Hyper Casual',
          genre_cn: '超休闲',
          genre_en: 'Hyper Casual',
        },
        {
          genre: 'Idler',
          genre_cn: '放置游戏',
          genre_en: 'Idler',
        },
        {
          genre: 'io',
          genre_cn: '休闲竞技',
          genre_en: 'io',
        },
        {
          genre: 'Life Sim',
          genre_cn: '模拟生活',
          genre_en: 'Life Sim',
        },
        {
          genre: 'Linking',
          genre_cn: '连连看',
          genre_en: 'Linking',
        },
        {
          genre: 'Management',
          genre_cn: '管理',
          genre_en: 'Management',
        },
        {
          genre: 'Match 3',
          genre_cn: '消除游戏',
          genre_en: 'Match 3',
        },
        {
          genre: 'Medical Sim',
          genre_cn: '模拟医院',
          genre_en: 'Medical Sim',
        },
        {
          genre: 'Merge game',
          genre_cn: '合并游戏',
          genre_en: 'Merge game',
        },
        {
          genre: 'Merge Games',
          genre_cn: '合并游戏',
          genre_en: 'Merge Games',
        },
        {
          genre: 'Music',
          genre_cn: '音乐',
          genre_en: 'Music',
        },
        {
          genre: 'Parkour',
          genre_cn: '跑酷',
          genre_en: 'Parkour',
        },
        {
          genre: 'Party Game',
          genre_cn: '派对游戏',
          genre_en: 'Party Game',
        },
        {
          genre: 'Physics',
          genre_cn: '物理',
          genre_en: 'Physics',
        },
        {
          genre: 'Point & Click',
          genre_cn: '点击式',
          genre_en: 'Point & Click',
        },
        {
          genre: 'Puzzle',
          genre_cn: '解密',
          genre_en: 'Puzzle',
        },
        {
          genre: 'Rhythm',
          genre_cn: '节奏',
          genre_en: 'Rhythm',
        },
        {
          genre: 'Rogue-like',
          genre_cn: '肉鸽',
          genre_en: 'Rogue-like',
        },
        {
          genre: "Shoot 'Em Up",
          genre_cn: '射击游戏',
          genre_en: "Shoot 'Em Up",
        },
        {
          genre: 'Social Deduction',
          genre_cn: '社交演绎',
          genre_en: 'Social Deduction',
        },
        {
          genre: 'Solitaire',
          genre_cn: '接龙',
          genre_en: 'Solitaire',
        },
        {
          genre: 'Story Rich',
          genre_cn: '故事丰富',
          genre_en: 'Story Rich',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Tanks',
          genre_cn: '坦克',
          genre_en: 'Tanks',
        },
        {
          genre: 'Tap',
          genre_cn: '点击',
          genre_en: 'Tap',
        },
        {
          genre: 'Third-Person Shooter',
          genre_cn: '第三人称射击',
          genre_en: 'Third-Person Shooter',
        },
        {
          genre: 'Tower Defense',
          genre_cn: '塔防',
          genre_en: 'Tower Defense',
        },
        {
          genre: 'Trivia',
          genre_cn: '冷知识',
          genre_en: 'Trivia',
        },
        {
          genre: 'Typing',
          genre_cn: '打字',
          genre_en: 'Typing',
        },
        {
          genre: 'Visual Story',
          genre_cn: '视觉小说',
          genre_en: 'Visual Story',
        },
        {
          genre: 'Word game',
          genre_cn: '文字游戏',
          genre_en: 'Word game',
        },
        {
          genre: 'Wrestling',
          genre_cn: '摔跤游戏',
          genre_en: 'Wrestling',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Gacha',
        genre_cn: '抽卡游戏',
        genre_en: 'Gacha',
      },
      sub_genre: [
        {
          genre: '2D Fighter',
          genre_cn: '2D战斗',
          genre_en: '2D Fighter',
        },
        {
          genre: '2D Platformer',
          genre_cn: '2D平台',
          genre_en: '2D Platformer',
        },
        {
          genre: 'Action RPG',
          genre_cn: '动作角色扮演',
          genre_en: 'Action RPG',
        },
        {
          genre: 'AR/Location Based',
          genre_cn: '基于位置的游戏',
          genre_en: 'AR/Location Based',
        },
        {
          genre: 'Arcade',
          genre_cn: '街机',
          genre_en: 'Arcade',
        },
        {
          genre: 'Base Building',
          genre_cn: '基地建设',
          genre_en: 'Base Building',
        },
        {
          genre: "Beat 'em up",
          genre_cn: '清版动作',
          genre_en: "Beat 'em up",
        },
        {
          genre: 'Boxing',
          genre_cn: '拳击',
          genre_en: 'Boxing',
        },
        {
          genre: 'Bullet Hell',
          genre_cn: '子弹地狱',
          genre_en: 'Bullet Hell',
        },
        {
          genre: 'Card Battler',
          genre_cn: '卡牌对战',
          genre_en: 'Card Battler',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Casual',
          genre_cn: '休闲',
          genre_en: 'Casual',
        },
        {
          genre: 'Chess',
          genre_cn: '象棋',
          genre_en: 'Chess',
        },
        {
          genre: 'Choices Matter',
          genre_cn: '选择向',
          genre_en: 'Choices Matter',
        },
        {
          genre: 'City Builder',
          genre_cn: '城市建造',
          genre_en: 'City Builder',
        },
        {
          genre: 'Clicker',
          genre_cn: '点击',
          genre_en: 'Clicker',
        },
        {
          genre: 'Combat Racing',
          genre_cn: '赛车视频',
          genre_en: 'Combat Racing',
        },
        {
          genre: 'Cooking',
          genre_cn: '烹饪',
          genre_en: 'Cooking',
        },
        {
          genre: 'Creature Collector',
          genre_cn: '生物收集',
          genre_en: 'Creature Collector',
        },
        {
          genre: 'Customization',
          genre_cn: '自定义',
          genre_en: 'Customization',
        },
        {
          genre: 'Dating Sim',
          genre_cn: '模拟约会',
          genre_en: 'Dating Sim',
        },
        {
          genre: 'Deckbuilding',
          genre_cn: '牌组构建',
          genre_en: 'Deckbuilding',
        },
        {
          genre: 'Dungeon Crawler',
          genre_cn: '地牢爬行者',
          genre_en: 'Dungeon Crawler',
        },
        {
          genre: 'Farm simulation',
          genre_cn: '农场模拟',
          genre_en: 'Farm simulation',
        },
        {
          genre: 'Fighting',
          genre_cn: '格斗',
          genre_en: 'Fighting',
        },
        {
          genre: 'Flight',
          genre_cn: '模拟飞行',
          genre_en: 'Flight',
        },
        {
          genre: 'Football (Soccer)',
          genre_cn: '',
          genre_en: 'Football (Soccer)',
        },
        {
          genre: 'Hack and Slash',
          genre_cn: '砍杀游戏',
          genre_en: 'Hack and Slash',
        },
        {
          genre: 'Horses',
          genre_cn: '赛马',
          genre_en: 'Horses',
        },
        {
          genre: 'Idler',
          genre_cn: '放置游戏',
          genre_en: 'Idler',
        },
        {
          genre: 'JRPG',
          genre_cn: '日式角色扮演游戏',
          genre_en: 'JRPG',
        },
        {
          genre: 'Life Sim',
          genre_cn: '模拟生活',
          genre_en: 'Life Sim',
        },
        {
          genre: 'Linking',
          genre_cn: '连连看',
          genre_en: 'Linking',
        },
        {
          genre: 'Management',
          genre_cn: '管理',
          genre_en: 'Management',
        },
        {
          genre: 'Match 3',
          genre_cn: '消除游戏',
          genre_en: 'Match 3',
        },
        {
          genre: 'MMORPG',
          genre_cn: '大型多人在线角色扮演游戏',
          genre_en: 'MMORPG',
        },
        {
          genre: 'MMOSLG',
          genre_cn: '大型多人在线战略游戏',
          genre_en: 'MMOSLG',
        },
        {
          genre: 'Music',
          genre_cn: '音乐',
          genre_en: 'Music',
        },
        {
          genre: 'Naval Combat',
          genre_cn: '海战游戏',
          genre_en: 'Naval Combat',
        },
        {
          genre: 'Open World',
          genre_cn: '开放世界',
          genre_en: 'Open World',
        },
        {
          genre: 'Party Game',
          genre_cn: '派对游戏',
          genre_en: 'Party Game',
        },
        {
          genre: 'Physics',
          genre_cn: '物理',
          genre_en: 'Physics',
        },
        {
          genre: 'Pinball',
          genre_cn: '弹球',
          genre_en: 'Pinball',
        },
        {
          genre: 'Point & Clicker',
          genre_cn: '点击游戏',
          genre_en: 'Point & Clicker',
        },
        {
          genre: 'Puzzle',
          genre_cn: '解密',
          genre_en: 'Puzzle',
        },
        {
          genre: 'Real Time Tactics',
          genre_cn: '即时战略',
          genre_en: 'Real Time Tactics',
        },
        {
          genre: 'Rhythm',
          genre_cn: '节奏',
          genre_en: 'Rhythm',
        },
        {
          genre: 'Roguelike',
          genre_cn: '肉鸽',
          genre_en: 'Roguelike',
        },
        {
          genre: "Shoot 'Em Up",
          genre_cn: '射击游戏',
          genre_en: "Shoot 'Em Up",
        },
        {
          genre: "Shoot'Em Up",
          genre_cn: '射击类清版动作',
          genre_en: "Shoot'Em Up",
        },
        {
          genre: 'Side Scroller',
          genre_cn: '横板动作游戏',
          genre_en: 'Side Scroller',
        },
        {
          genre: 'Story Rich',
          genre_cn: '故事丰富',
          genre_en: 'Story Rich',
        },
        {
          genre: 'Strategy RPG',
          genre_cn: '策略角色扮演',
          genre_en: 'Strategy RPG',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Tanks',
          genre_cn: '坦克',
          genre_en: 'Tanks',
        },
        {
          genre: 'Tap',
          genre_cn: '点击',
          genre_en: 'Tap',
        },
        {
          genre: 'Third-Person Shooter',
          genre_cn: '第三人称射击',
          genre_en: 'Third-Person Shooter',
        },
        {
          genre: 'Tower Defense',
          genre_cn: '塔防',
          genre_en: 'Tower Defense',
        },
        {
          genre: 'Trading Card Game',
          genre_cn: '交易纸牌',
          genre_en: 'Trading Card Game',
        },
        {
          genre: 'Trivia',
          genre_cn: '冷知识',
          genre_en: 'Trivia',
        },
        {
          genre: 'Turn-Based',
          genre_cn: '回合制',
          genre_en: 'Turn-Based',
        },
        {
          genre: 'Turn-Based Combat',
          genre_cn: '回合制战斗',
          genre_en: 'Turn-Based Combat',
        },
        {
          genre: 'Turn-Based Strategy',
          genre_cn: '回合制战略',
          genre_en: 'Turn-Based Strategy',
        },
        {
          genre: 'Vehicular Combat',
          genre_cn: '载具作战',
          genre_en: 'Vehicular Combat',
        },
        {
          genre: 'Visual Story',
          genre_cn: '视觉小说',
          genre_en: 'Visual Story',
        },
        {
          genre: 'Word game',
          genre_cn: '文字游戏',
          genre_en: 'Word game',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Gambling',
        genre_cn: '赌博',
        genre_en: 'Gambling',
      },
      sub_genre: [
        {
          genre: 'Gambling',
          genre_cn: '赌博',
          genre_en: 'Gambling',
        },
      ],
    },
    // {
    //   main_genre: {
    //     genre: 'Arcade',
    //     genre_cn: '街机',
    //     genre_en: 'Arcade',
    //   },
    // },
    {
      main_genre: {
        genre: 'Racing',
        genre_cn: '竞速',
        genre_en: 'Racing',
      },
      sub_genre: [
        {
          genre: 'Automobile Sim',
          genre_cn: '模拟驾驶',
          genre_en: 'Automobile Sim',
        },
        {
          genre: 'Casual',
          genre_cn: '休闲',
          genre_en: 'Casual',
        },
        {
          genre: 'Combat Racing',
          genre_cn: '赛车视频',
          genre_en: 'Combat Racing',
        },
        {
          genre: 'Driving',
          genre_cn: '驾驶',
          genre_en: 'Driving',
        },
        {
          genre: 'Horses',
          genre_cn: '赛马',
          genre_en: 'Horses',
        },
        {
          genre: 'Offroad',
          genre_cn: '越野',
          genre_en: 'Offroad',
        },
        {
          genre: 'Physics',
          genre_cn: '物理',
          genre_en: 'Physics',
        },
        {
          genre: 'Puzzle',
          genre_cn: '解密',
          genre_en: 'Puzzle',
        },
      ],
    },
    {
      main_genre: {
        genre: 'RPG',
        genre_cn: '角色扮演',
        genre_en: 'RPG',
      },
      sub_genre: [
        {
          genre: '2D Fighter',
          genre_cn: '2D战斗',
          genre_en: '2D Fighter',
        },
        {
          genre: '2D Platformer',
          genre_cn: '2D平台',
          genre_en: '2D Platformer',
        },
        {
          genre: 'Action RPG',
          genre_cn: '动作角色扮演',
          genre_en: 'Action RPG',
        },
        {
          genre: 'AR/Location Based',
          genre_cn: '基于位置的游戏',
          genre_en: 'AR/Location Based',
        },
        {
          genre: 'Base Building',
          genre_cn: '基地建设',
          genre_en: 'Base Building',
        },
        {
          genre: 'Battle Royale',
          genre_cn: '大逃杀',
          genre_en: 'Battle Royale',
        },
        {
          genre: "Beat 'em up",
          genre_cn: '清版动作',
          genre_en: "Beat 'em up",
        },
        {
          genre: 'Building',
          genre_cn: '建筑',
          genre_en: 'Building',
        },
        {
          genre: 'Card Battler',
          genre_cn: '卡牌对战',
          genre_en: 'Card Battler',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Casual',
          genre_cn: '休闲',
          genre_en: 'Casual',
        },
        {
          genre: 'Clicker',
          genre_cn: '点击',
          genre_en: 'Clicker',
        },
        {
          genre: 'Creature Collector',
          genre_cn: '生物收集',
          genre_en: 'Creature Collector',
        },
        {
          genre: 'Dungeon Crawler',
          genre_cn: '地牢爬行者',
          genre_en: 'Dungeon Crawler',
        },
        {
          genre: 'Exploration',
          genre_cn: '探索',
          genre_en: 'Exploration',
        },
        {
          genre: 'Fighting',
          genre_cn: '格斗',
          genre_en: 'Fighting',
        },
        {
          genre: 'Hack and Slash',
          genre_cn: '砍杀游戏',
          genre_en: 'Hack and Slash',
        },
        {
          genre: 'Hunting',
          genre_cn: '狩猎',
          genre_en: 'Hunting',
        },
        {
          genre: 'Idler',
          genre_cn: '放置游戏',
          genre_en: 'Idler',
        },
        {
          genre: 'JRPG',
          genre_cn: '日式角色扮演游戏',
          genre_en: 'JRPG',
        },
        {
          genre: 'Life Sim',
          genre_cn: '模拟生活',
          genre_en: 'Life Sim',
        },
        {
          genre: 'MMORPG',
          genre_cn: '大型多人在线角色扮演游戏',
          genre_en: 'MMORPG',
        },
        {
          genre: 'Naval Combat',
          genre_cn: '海战游戏',
          genre_en: 'Naval Combat',
        },
        {
          genre: 'Open World',
          genre_cn: '开放世界',
          genre_en: 'Open World',
        },
        {
          genre: 'Open World Survival Craft',
          genre_cn: '开放世界生存建造',
          genre_en: 'Open World Survival Craft',
        },
        {
          genre: 'Real Time Tactics',
          genre_cn: '即时战略',
          genre_en: 'Real Time Tactics',
        },
        {
          genre: 'Rogue-like',
          genre_cn: '肉鸽',
          genre_en: 'Rogue-like',
        },
        {
          genre: 'Sandbox',
          genre_cn: '沙盒',
          genre_en: 'Sandbox',
        },
        {
          genre: 'Side Scroller',
          genre_cn: '横板动作游戏',
          genre_en: 'Side Scroller',
        },
        {
          genre: 'Story Rich',
          genre_cn: '故事丰富',
          genre_en: 'Story Rich',
        },
        {
          genre: 'Strategy RPG',
          genre_cn: '策略角色扮演',
          genre_en: 'Strategy RPG',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Third-Person Shooter',
          genre_cn: '第三人称射击',
          genre_en: 'Third-Person Shooter',
        },
        {
          genre: 'Turn-Based Combat',
          genre_cn: '回合制战斗',
          genre_en: 'Turn-Based Combat',
        },
        {
          genre: 'Visual Story',
          genre_cn: '视觉小说',
          genre_en: 'Visual Story',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Shooter',
        genre_cn: '射击',
        genre_en: 'Shooter',
      },
      sub_genre: [
        {
          genre: 'Battle Royal',
          genre_cn: '皇家战斗',
          genre_en: 'Battle Royal',
        },
        {
          genre: 'Battle Royale',
          genre_cn: '大逃杀',
          genre_en: 'Battle Royale',
        },
        {
          genre: 'Building',
          genre_cn: '建筑',
          genre_en: 'Building',
        },
        {
          genre: 'Bullet Hell',
          genre_cn: '子弹地狱',
          genre_en: 'Bullet Hell',
        },
        {
          genre: 'Card Battler',
          genre_cn: '卡牌对战',
          genre_en: 'Card Battler',
        },
        {
          genre: 'Customization',
          genre_cn: '自定义',
          genre_en: 'Customization',
        },
        {
          genre: 'Driving',
          genre_cn: '驾驶',
          genre_en: 'Driving',
        },
        {
          genre: 'Dungeon Crawler',
          genre_cn: '地牢爬行者',
          genre_en: 'Dungeon Crawler',
        },
        {
          genre: 'FPS',
          genre_cn: '第一人称射击',
          genre_en: 'FPS',
        },
        {
          genre: 'MOBA',
          genre_cn: '多人在线战术竞技游戏',
          genre_en: 'MOBA',
        },
        {
          genre: 'Naval Combat',
          genre_cn: '海战游戏',
          genre_en: 'Naval Combat',
        },
        {
          genre: 'On-Rails Shooter',
          genre_cn: '地铁狙击',
          genre_en: 'On-Rails Shooter',
        },
        {
          genre: 'Open World Survival Craft',
          genre_cn: '开放世界生存建造',
          genre_en: 'Open World Survival Craft',
        },
        {
          genre: 'Physics',
          genre_cn: '物理',
          genre_en: 'Physics',
        },
        {
          genre: 'Rogue-like',
          genre_cn: '肉鸽',
          genre_en: 'Rogue-like',
        },
        {
          genre: 'Sniper',
          genre_cn: '狙击',
          genre_en: 'Sniper',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Tactical',
          genre_cn: '战术',
          genre_en: 'Tactical',
        },
        {
          genre: 'Tanks',
          genre_cn: '坦克',
          genre_en: 'Tanks',
        },
        {
          genre: 'Third-Person Shooter',
          genre_cn: '第三人称射击',
          genre_en: 'Third-Person Shooter',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Simulation',
        genre_cn: '模拟生活',
        genre_en: 'Simulation',
      },
      sub_genre: [
        {
          genre: 'Base Building',
          genre_cn: '基地建设',
          genre_en: 'Base Building',
        },
        {
          genre: 'Building',
          genre_cn: '建筑',
          genre_en: 'Building',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Casual',
          genre_cn: '休闲',
          genre_en: 'Casual',
        },
        {
          genre: 'City Builder',
          genre_cn: '城市建造',
          genre_en: 'City Builder',
        },
        {
          genre: 'Clicker',
          genre_cn: '点击',
          genre_en: 'Clicker',
        },
        {
          genre: 'Colony Sim',
          genre_cn: '模拟殖民',
          genre_en: 'Colony Sim',
        },
        {
          genre: 'Cooking',
          genre_cn: '烹饪',
          genre_en: 'Cooking',
        },
        {
          genre: 'Creature Collector',
          genre_cn: '生物收集',
          genre_en: 'Creature Collector',
        },
        {
          genre: 'Customization',
          genre_cn: '自定义',
          genre_en: 'Customization',
        },
        {
          genre: 'Design & Illustration',
          genre_cn: '设计和插图',
          genre_en: 'Design & Illustration',
        },
        {
          genre: 'Farm simulation',
          genre_cn: '农场模拟',
          genre_en: 'Farm simulation',
        },
        {
          genre: 'Farming Sim',
          genre_cn: '模拟农场',
          genre_en: 'Farming Sim',
        },
        {
          genre: 'Flight',
          genre_cn: '模拟飞行',
          genre_en: 'Flight',
        },
        {
          genre: 'FPS',
          genre_cn: '第一人称射击',
          genre_en: 'FPS',
        },
        {
          genre: 'Hunting',
          genre_cn: '狩猎',
          genre_en: 'Hunting',
        },
        {
          genre: 'Idler',
          genre_cn: '放置游戏',
          genre_en: 'Idler',
        },
        {
          genre: 'Life Sim',
          genre_cn: '模拟生活',
          genre_en: 'Life Sim',
        },
        {
          genre: 'Management',
          genre_cn: '管理',
          genre_en: 'Management',
        },
        {
          genre: 'Merge Games',
          genre_cn: '合并游戏',
          genre_en: 'Merge Games',
        },
        {
          genre: 'Open World',
          genre_cn: '开放世界',
          genre_en: 'Open World',
        },
        {
          genre: 'Sandbox',
          genre_cn: '沙盒',
          genre_en: 'Sandbox',
        },
        {
          genre: 'Story Rich',
          genre_cn: '故事丰富',
          genre_en: 'Story Rich',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Time Management',
          genre_cn: '时间管理',
          genre_en: 'Time Management',
        },
        {
          genre: 'Trains',
          genre_cn: '火车',
          genre_en: 'Trains',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Sports',
        genre_cn: '运动',
        genre_en: 'Sports',
      },
      sub_genre: [
        {
          genre: 'Baseball',
          genre_cn: '棒球',
          genre_en: 'Baseball',
        },
        {
          genre: 'Basketball',
          genre_cn: '篮球',
          genre_en: 'Basketball',
        },
        {
          genre: 'Bowling',
          genre_cn: '保龄球',
          genre_en: 'Bowling',
        },
        {
          genre: 'Boxing',
          genre_cn: '拳击',
          genre_en: 'Boxing',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Casual',
          genre_cn: '休闲',
          genre_en: 'Casual',
        },
        {
          genre: 'e-sports',
          genre_cn: '电子竞技',
          genre_en: 'e-sports',
        },
        {
          genre: 'fighting',
          genre_cn: '',
          genre_en: 'fighting',
        },
        {
          genre: 'Fishing',
          genre_cn: '钓鱼',
          genre_en: 'Fishing',
        },
        {
          genre: 'Football (Soccer)',
          genre_cn: '',
          genre_en: 'Football (Soccer)',
        },
        {
          genre: 'Golf',
          genre_cn: '高尔夫',
          genre_en: 'Golf',
        },
        {
          genre: 'JRPG',
          genre_cn: '日式角色扮演游戏',
          genre_en: 'JRPG',
        },
        {
          genre: 'Management',
          genre_cn: '管理',
          genre_en: 'Management',
        },
        {
          genre: 'Pool',
          genre_cn: '泳池',
          genre_en: 'Pool',
        },
        {
          genre: 'Tennis',
          genre_cn: '网球',
          genre_en: 'Tennis',
        },
        {
          genre: 'Visual Story',
          genre_cn: '视觉小说',
          genre_en: 'Visual Story',
        },
      ],
    },
    {
      main_genre: {
        genre: 'Strategy',
        genre_cn: '策略',
        genre_en: 'Strategy',
      },
      sub_genre: [
        {
          genre: 'Auto Battler',
          genre_cn: '自动战斗',
          genre_en: 'Auto Battler',
        },
        {
          genre: 'Base Building',
          genre_cn: '基地建设',
          genre_en: 'Base Building',
        },
        {
          genre: 'Battle Royale',
          genre_cn: '大逃杀',
          genre_en: 'Battle Royale',
        },
        {
          genre: 'Board Game',
          genre_cn: '棋盘',
          genre_en: 'Board Game',
        },
        {
          genre: 'Card Battler',
          genre_cn: '卡牌对战',
          genre_en: 'Card Battler',
        },
        {
          genre: 'Card Game',
          genre_cn: '卡牌',
          genre_en: 'Card Game',
        },
        {
          genre: 'Casual',
          genre_cn: '休闲',
          genre_en: 'Casual',
        },
        {
          genre: 'COC-like',
          genre_cn: '',
          genre_en: 'COC-like',
        },
        {
          genre: 'COK-like',
          genre_cn: '类COK',
          genre_en: 'COK-like',
        },
        {
          genre: 'Deckbuilding',
          genre_cn: '牌组构建',
          genre_en: 'Deckbuilding',
        },
        {
          genre: 'Grand Strategy',
          genre_cn: '大战略',
          genre_en: 'Grand Strategy',
        },
        {
          genre: 'Hex Grid',
          genre_cn: '六角形',
          genre_en: 'Hex Grid',
        },
        {
          genre: 'Idler',
          genre_cn: '放置游戏',
          genre_en: 'Idler',
        },
        {
          genre: 'Life Sim',
          genre_cn: '模拟生活',
          genre_en: 'Life Sim',
        },
        {
          genre: 'Management',
          genre_cn: '管理',
          genre_en: 'Management',
        },
        {
          genre: 'Match 3',
          genre_cn: '消除游戏',
          genre_en: 'Match 3',
        },
        {
          genre: 'Merge Games',
          genre_cn: '合并游戏',
          genre_en: 'Merge Games',
        },
        {
          genre: 'MMOSLG',
          genre_cn: '大型多人在线战略游戏',
          genre_en: 'MMOSLG',
        },
        {
          genre: 'MOBA',
          genre_cn: '多人在线战术竞技游戏',
          genre_en: 'MOBA',
        },
        {
          genre: 'Naval Combat',
          genre_cn: '海战游戏',
          genre_en: 'Naval Combat',
        },
        {
          genre: 'Outbreak Sim',
          genre_cn: '僵尸爆发模拟',
          genre_en: 'Outbreak Sim',
        },
        {
          genre: 'Physics',
          genre_cn: '物理',
          genre_en: 'Physics',
        },
        {
          genre: 'Puzzle',
          genre_cn: '解密',
          genre_en: 'Puzzle',
        },
        {
          genre: 'Rogue-like',
          genre_cn: '肉鸽',
          genre_en: 'Rogue-like',
        },
        {
          genre: 'ROK-like',
          genre_cn: '类似 ROK',
          genre_en: 'ROK-like',
        },
        {
          genre: 'RTS',
          genre_cn: '即时战略',
          genre_en: 'RTS',
        },
        {
          genre: 'ShuaiTu-like',
          genre_cn: '率土',
          genre_en: 'ShuaiTu-like',
        },
        {
          genre: 'Strategy RPG',
          genre_cn: '策略角色扮演',
          genre_en: 'Strategy RPG',
        },
        {
          genre: 'Survival',
          genre_cn: '生存',
          genre_en: 'Survival',
        },
        {
          genre: 'Tactical',
          genre_cn: '战术',
          genre_en: 'Tactical',
        },
        {
          genre: 'Tanks',
          genre_cn: '坦克',
          genre_en: 'Tanks',
        },
        {
          genre: 'Tower Defense',
          genre_cn: '塔防',
          genre_en: 'Tower Defense',
        },
        {
          genre: 'Trading Card Game',
          genre_cn: '交易纸牌',
          genre_en: 'Trading Card Game',
        },
        {
          genre: 'Turn-Based Combat',
          genre_cn: '回合制战斗',
          genre_en: 'Turn-Based Combat',
        },
        {
          genre: 'Wargame',
          genre_cn: '战争游戏',
          genre_en: 'Wargame',
        },
      ],
    },
  ],
};
